import type { NotificationGroups } from 'app/src/components/NotificationsMenu';
import { notificationsState } from 'app/src/components/NotificationsMenu';

const getNotificationGroupByNotificationId = (
  notificationGroups: NotificationGroups,
  idNotification: string,
) => {
  const groups = notificationGroups.find(({ notifications }) =>
    notifications.find(({ id }) => id === idNotification),
  );

  return groups ?? null;
};

const getNotificationByActionId = (
  notificationGroups: NotificationGroups,
  idAction: string,
) => {
  const [notificationGroup] = notificationGroups.filter(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (notificationGroup: NotificationGroups[number]) => {
      return notificationGroup.notifications.filter(
        (notification) => notification.idAction === idAction,
      ).length;
    },
  );

  return notificationGroup ? notificationGroup.notifications[0] : null;
};

export const getReactionAnalyticsContainersByActionId = (idAction: string) => {
  if (!idAction) {
    return {};
  }

  const notification = getNotificationByActionId(
    notificationsState.value.notificationGroups,
    idAction,
  );
  const notificationGroup = notification
    ? getNotificationGroupByNotificationId(
        notificationsState.value.notificationGroups,
        notification.id,
      )
    : null;

  return {
    idBoard: notification?.data?.board?.id,
    idCard: notification?.data?.card?.id,
    idList: notificationGroup?.card?.list?.id,
  };
};
